import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Menu from './components/Menu';
import About from './components/About';
import Footer from './components/Footer';

function App() {
  const [showLogoModal, setShowLogoModal] = useState(true);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsClosing(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleAnimationEnd = () => {
    if (isClosing) {
      setShowLogoModal(false);
    }
  };

  return (
    <>
      {showLogoModal && (
        <div 
          className={`logo-modal fixed inset-0 z-[1000] flex items-center justify-center bg-black/95 backdrop-blur-xl ${isClosing ? 'closing' : ''}`}
          onAnimationEnd={handleAnimationEnd}
        >
          <img 
            src="/logo.jpg" 
            alt="Prime Eats Logo" 
            className="logo-img w-32 md:w-48 lg:w-64 h-32 md:h-48 lg:h-64 rounded-2xl object-cover animate-pulse"
          />
        </div>
      )}
      <Router>
        <div className="bg-[#0a0a0a] min-h-screen flex flex-col scroll-smooth">
          <Header />
          
          <main className="flex-grow">
            <Routes>
              {/* Home Page: Hero + Menu stacked */}
              <Route path="/" element={
                <>
                  <Home />
                  <Menu />
                </>
              } />

              {/* Separate About Page */}
              <Route path="/about" element={<About />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;